import { usePage, router } from "@inertiajs/react"
import type { SharedProps } from "@/types"

export default function ImpersonationBanner() {
  const { impersonating, originalAdminName } = usePage<SharedProps>().props

  if (!impersonating) return null

  return (
    <div className="fixed inset-x-0 top-0 z-50 flex min-h-10 flex-wrap items-center justify-center gap-x-3 gap-y-0.5 bg-red px-3 py-1.5 text-center text-xs font-medium text-white sm:text-sm">
      <span className="whitespace-nowrap">
        Viewing as impersonated user &middot; Admin: {originalAdminName}
      </span>
      <button
        onClick={() => router.post("/admin/stop-impersonating")}
        className="shrink-0 rounded bg-white/20 px-2.5 py-0.5 text-xs font-semibold transition-colors hover:bg-white/30"
      >
        Stop impersonating
      </button>
    </div>
  )
}
